import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import { useEffect, useState } from "react";
import { useUpdateCustomerDetails } from "@hooks/useUpdateCustomerDetails";
import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";
import "./css/customerDetailsPage.scss";
import { CustomerDetailsForm } from "@features/customerDetails/CustomerDetailsForm";
import { useGetCustomerDetails } from "@features/customerDetails/hook/useGetCustomerDetails";
import { useHistory } from "react-router-dom";
import { useGetCart } from "@hooks/useGetCart";
import { ICart } from "@features/cart/ICart";

export const CustomerDetailsPage = () => {
    const { push, location } = useHistory();
    const [scrollToError, setScrollToError] = useState(false);
    const [getCustomerDetailsLoading, setGetCustomerDetailsLoading] = useState(true);
    const [customerDetails, setCustomerDetails] = useState<ICustomerDetails>();
    const [getCartIsLoading, setGetCartIsLoading] = useState(true);
    const [cart, setCart] = useState<ICart>();
    const [emailError, setEmailError] = useState<string>();

    const callbackGetCustomerDetails = (customerDetailsGet?: ICustomerDetails) => {
        if (customerDetailsGet) {
            setCustomerDetails(customerDetailsGet);
        }
        setGetCustomerDetailsLoading(false);
    };

    const callbackGetCart = (cart?: ICart) => {
        if (cart) {
            setCart(cart);
        }
        setGetCartIsLoading(false);
    };

    const { getCustomerDetails, getCustomerDetailsState } = useGetCustomerDetails(push, callbackGetCustomerDetails);
    const { userCartState } = useGetCart(callbackGetCart);
    const { updateCustomerDetails, updateCustomerDetailsState, updateCustomerDetailsError } = useUpdateCustomerDetails(
        push
    );

    useEffect(() => {
        if (scrollToError) {
            const errorElement = document.querySelector('[id^="error-text-"]');

            if (errorElement) {
                errorElement.scrollIntoView(true);
                window.scrollBy(0, -200);
            }

            setScrollToError(false);
        }
    }, [scrollToError]);

    let retry;

    if (getCustomerDetailsState.error) {
        retry = getCustomerDetails;
    }

    if (updateCustomerDetailsError) {
        retry = () => window.location.reload();
    }

    const isLoading =
        getCustomerDetailsLoading ||
        updateCustomerDetailsState.isLoading ||
        getCartIsLoading ||
        userCartState.isLoading;

    const error = getCustomerDetailsState.error ?? updateCustomerDetailsError;

    const updateDetails = (customerDetailsRequest: ICustomerDetails, privacyPolicy: boolean) => {
        setCustomerDetails(customerDetailsRequest);

        return updateCustomerDetails(customerDetailsRequest, privacyPolicy, setEmailError);
    };

    return (
        <div className="container-boxed">
            <HandleErrorAndLoading error={error} isLoading={isLoading} retryFetch={retry}>
                {customerDetails && (
                    <CustomerDetailsForm
                        customerDetails={customerDetails}
                        emailError={emailError}
                        pathName={location.pathname}
                        setScrollToError={setScrollToError}
                        updateCustomerDetails={updateDetails}
                        userCart={cart}
                    />
                )}
            </HandleErrorAndLoading>
        </div>
    );
};
